<template>
    <div id="home">
        <HeroSlideshow></HeroSlideshow>
        <div class="navigation-header">
            <div class="navigation-links">
                <router-link to="/properties">
                    <img src="/images/ic-properties.svg">
                    Properties
                </router-link>
                <router-link to="/about">
                    <img src="/images/ic-team.svg">
                    Meet The Team
                </router-link>
                <router-link to="/testimonials">
                    <img src="/images/ic-testimonials.svg">
                    Testimonials
                </router-link>
            </div>
        </div>
        <p class="navigation-text">
            At Minnesota Premier Realty, our philosophy is simple: to center our focus on the wants and needs of each individual client. Our success comes from cultivating strong relationships and offering personalized service that is catered to each individual.
        </p>
        <FeaturedProperties />
        <Testimonial />
    </div>
</template>

<script>
import HeroSlideshow from "../components/HeroSlideshow"
import Testimonial from '../components/Testimonial'
import FeaturedProperties from '../components/FeaturedProperties'

export default {
    name: "Home",
    components: {
        HeroSlideshow,
        Testimonial,
        FeaturedProperties
    },
    metaInfo: {
        title: 'Minnesota Premier | Luxury Real Estate',
        meta: [{
            name: 'description', 
            content: "Minnesota Premier | Luxury Real Estate"
        }]
    },
    data(){
        return{
            introTitle: "Minnesota Premier",
            homePageContent: "As Director of Luxury Estates with Sally Forster Jones Group, one of the leading teams in the world, with over $5billion in sales volume, Kathryn leverages an impressive portfolio of communication and negotiation skills to facilitate transactions, find off-market properties, attract multiple offers, and compose eloquent offers to earn winning results for both sellers and buyers. She also is very intuitive in matching her clients with the perfect home.",
        }
    },
}   
</script>

<style lang="scss" scoped>
.navigation-header{
    background: #2260ad;
    color:#fff;
    padding: 1.5rem 0;
    .navigation-links{
        display: flex;
        justify-content: center;
        height: 117px;
        a{
            color: #fff;
            text-decoration: none;
            display: flex;
            align-items: center;
            padding-right: 22px;
            padding-left: 22px;
            border-right: 1px solid rgba($color: #fff, $alpha: 0.3);
            font-size: 22px;
            font-weight: 500;
            img{
                margin-right: 8px;
                height: 35px;
            }
            &:last-child{
                border-right: none;
            }
        }
    }
}

.navigation-text{
    margin: 0 auto;
    margin-top: 4rem;
    text-align: center;
    max-width: 700px;
    width: 80%;
}

@media (max-width: $mobile) { 
    .navigation-header{
        display: none;
    }
    .navigation-text{
        margin: 0 auto;
        margin-top: 4rem;
        margin-bottom: 4rem;
        text-align: center;
        max-width: 700px;
        width: 80%;
    }
}
</style>